import { render } from "./WaresItem.vue?vue&type=template&id=688d522a"
import script from "./WaresItem.vue?vue&type=script&lang=js"
export * from "./WaresItem.vue?vue&type=script&lang=js"

import "./WaresItem.vue?vue&type=style&index=0&id=688d522a&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__